module.exports = __webpack_public_path__ + "img/ruiyan_03.54df3ee0.jpg";